import { combineReducers } from 'redux';
import { IBookingEventSummary, IEventV2 } from '../../../../../data/entities/event';
import { ActionTypes as BookingActionTypes } from '../../../../../entities/bookings/actions';
import { ActionTypes as FXActionTypes } from '../../../../../entities/fx/actions';
import { SaveState } from '../../../../../types';
import automationProcess from './automation-process/reducers';

const defaultPropertyId = {} as { [key: string]: IBookingEventSummary[] };

export const byPropertyId = (state = defaultPropertyId, action: any = {} as any) => {
	switch (action.type) {
		case BookingActionTypes.BOOKINGS_GET_BY_PROP_ID_RECEIVE:
			return { ...state, [action.payload.id]: action.payload.bookings };
		default:
			return state;
	}
};

const defaultId = {} as { [key: string]: IEventV2 };

export const byId = (state = defaultId, action: any = {} as any) => {
	switch (action.type) {
		case BookingActionTypes.BOOKINGS_GET_BY_ID_RECEIVE:
			return { ...state, [action.payload.id]: action.payload };
		case BookingActionTypes.BOOKINGV2_UPDATE_RECEIVE:
			return { ...state, [action.payload.eventId]: action.payload.event };
		default:
			return state;
	}
};

export const saving = (state = SaveState.NONE, action: any = {} as any) => {
	switch (action.type) {
		case BookingActionTypes.BOOKINGV2_UPDATE_REQUEST:
			return SaveState.PENDING;
		case BookingActionTypes.BOOKINGV2_UPDATE_RECEIVE:
			return SaveState.SUCCESS;
		case BookingActionTypes.BOOKINGV2_UPDATE_FAILURE:
			return SaveState.FAILURE;
		default:
			return state;
	}
};

export const fxRatesByEvent = (state = {} as { [key: string]: any }, action: any = {} as any) => {
	switch (action.type) {
		case FXActionTypes.GET_FX_RATES_FOR_EVENT_RECEIVE:
			return { ...state, [action.payload.id]: action.payload.rates };
		default:
			return state;
	}
};

interface IBookingViewPageState {
	byPropertyId: ReturnType<typeof byPropertyId>;
	byId: ReturnType<typeof byId>;
	saving: ReturnType<typeof saving>;
	fxRatesByEvent: ReturnType<typeof fxRatesByEvent>;
	automationProcess: ReturnType<typeof automationProcess>;
}

export default combineReducers<IBookingViewPageState>({
	byPropertyId,
	byId,
	saving,
	fxRatesByEvent,
	automationProcess
});
